import {
  ApplicationConfig,
  importProvidersFrom, inject, provideAppInitializer,
  provideBrowserGlobalErrorListeners
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay, withNoIncrementalHydration } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '@env/environment';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IpBlacklistService } from '@services/ipBlacklist.service';

export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
      ), provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    provideAppInitializer(() => inject(IpBlacklistService).resolve()),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader({
          prefix: `/assets/i18n/${environment.country}/`,
          suffix: '.json'
        }),
        fallbackLang: environment.language,
      })
    ]),
  ],
};
